import { render } from "./PostLessonPrompt.vue?vue&type=template&id=06ee8c29&scoped=true"
import script from "./PostLessonPrompt.vue?vue&type=script&lang=js"
export * from "./PostLessonPrompt.vue?vue&type=script&lang=js"

import "./PostLessonPrompt.vue?vue&type=style&index=0&id=06ee8c29&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ee8c29"]])

export default __exports__